var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon-arrow-down",attrs:{"viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8 13.92l-8-8.195 2.342-2.342 5.658 5.657 5.648-5.657 2.352 2.343z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }